import type { FilterOption } from "@shared/types/filters"
import type { StatusFilterItem, StatusMappings } from '@shared/types/status-filter.types'
import {
  getEntityStatusFilters,
  getEntityStatusOptions,
  getEntityStatusMappings,
  ENTITY_REGISTRY,
  type RegisteredEntityType
} from '@shared/config/entities'

export type EntityType = RegisteredEntityType

export const StatusRegistry = {
  getFilters: (entityType: EntityType): readonly StatusFilterItem[] => {
    return getEntityStatusFilters(entityType)
  },

  getOptions: (entityType: EntityType): readonly (FilterOption | string)[] => {
    return getEntityStatusOptions(entityType)
  },

  getMappings: (entityType: EntityType): StatusMappings => {
    return getEntityStatusMappings(entityType)
  },

  hasEntity: (entityType: string): entityType is EntityType => {
    return entityType in ENTITY_REGISTRY
  },

  getEntityTypes: (): EntityType[] => {
    return Object.keys(ENTITY_REGISTRY) as EntityType[]
  }
} as const
